/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface DisplaySettingsSignature {
  Args: {
    overlayColor: string;
    overlayColorAlpha: number;
    messageWidth: number;
    canSetColor: boolean;
    onChange: (newOverlayColor: string, overlayColorAlpha: number, newMessageWidth: number) => unknown;
  };
  Element: HTMLDivElement;
}

export default class DisplaySettings extends Component<DisplaySettingsSignature> {
  @tracked isOverlayColorTouched = false;

  get displayMessageWidth() {
    if (this.args.messageWidth === 0) {
      return '';
    }
    return this.args.messageWidth;
  }

  get displaySettingsErrors() {
    if (!this.args.overlayColor.match(/^#[0-9A-Fa-f]{6}$/)) {
      return ['Please enter a valid hex color code (Ex: #000000)'];
    } else {
      return [];
    }
  }

  @action
  markOverlayColorAsTouched() {
    if (!this.isOverlayColorTouched) {
      this.isOverlayColorTouched = true;
    }
  }
}
